import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'scheduled-change-startdate';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Start date/time',
};

const ScheduledChangeStartDate = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { ScheduledChangeStartDate };
